import React from "react";

export default function PrivacyPolicy() {
    return (
        <div className="legal-page">
            <div className="container">
                <div className="legal-card">
                    <h1 className="legal-title">Privacy Policy</h1>
                    <div className="legal-section">
                        <p>
                            Nsphere Healthcare is owned and operated by
                            <strong> COOPERWIND INDIA PRIVATE LIMITED</strong>.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h4>Information Collection</h4>
                        <p>
                            The platform may collect patient information,
                            appointment details, contact information and
                            healthcare-related operational data as required
                            for service delivery.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h4>WhatsApp Notifications</h4>
                        <p>
                            Nsphere Healthcare may send appointment confirmations,
                            reminders, rescheduling notifications and service-related
                            communications through WhatsApp and other communication channels.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h4>Data Security</h4>
                        <p>
                            We implement appropriate technical and organizational
                            measures to protect information processed through the platform.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h4>Contact</h4>
                        <p>
                            For privacy-related concerns contact:
                            <br />
                            TL-Support@Cooperwind.in
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}